import { z } from "zod";

export const signupFormSchema = z.object({
  email: z
    .string()
    .min(1, "Please provide your email.")
    .email("Invalid email."),
  mealPrepToken: z.string().optional(),
  metaAttribution: z
    .object({
      eventId: z.string().max(80),
      fbc: z.string().max(256),
      fbp: z.string().max(256),
      utmSource: z.string().max(100),
      utmMedium: z.string().max(100),
      utmCampaign: z.string().max(100),
      utmContent: z.string().max(100),
      signupUrl: z.string().max(1024),
    })
    .optional(),
});

export const metaSignupAttributionSchema =
  signupFormSchema.shape.metaAttribution;

export type SignupFormSchema = z.infer<typeof signupFormSchema>;

export const loginFormSchema = z.object({
  email: z
    .string()
    .min(1, "Please provide your email.")
    .email("Invalid email."),
  password: z.string().min(1, "Please provide your password."),
  mealPrepToken: z.string().optional(),
});

export type LoginFormSchema = z.infer<typeof loginFormSchema>;

const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters.")
  .regex(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
    "Password must contain at least one uppercase letter, one lowercase letter, and one number.",
  );

export const createPasswordFormSchema = z.object({
  password: passwordSchema,
});

export type CreatePasswordFormSchema = z.infer<typeof createPasswordFormSchema>;

export const resetPasswordFormSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string().min(1, "Please confirm your password."),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match.",
    path: ["confirmPassword"],
  });

export type ResetPasswordFormSchema = z.infer<typeof resetPasswordFormSchema>;
